// NCXPrivacyPolicyBig.jsx
import React from "react";
import DOMPurify from "dompurify";
import { s360ConfigService } from "../../../Services/S360Config";
import { DATA_TEST_ID_PREFIX, LIVECHAT_CLICK_EVENTS } from "../../../../utils/Constants/statsig.constants";

export default function NCXPrivacyPolicyBig({ config, onAccept }) {
  const configprimaryColor =
    s360ConfigService.config?.configDetails?.primaryColor;

  if (!config?.enabled) return null;

  return (
    <div
      className="ncx-privacy-policy-big"
      style={{
        backgroundColor: "#ffffff",
        padding: "20px",
        borderRadius: "8px",
        fontFamily: "Arial, sans-serif",
        maxWidth: "450px",
        margin: "20px auto",
        textAlign: "left",
        height: "100%",
      }}
    >
      <div style={{ height: "85%" }}>
        <div
          style={{
            fontSize: "14px",
            color: "#333",
            lineHeight: "1.6",
            marginBottom: "12px",
          }}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(config.text),
          }}
        />
        {config.url && (
          <a
            href={config.url}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "#007bff",

              fontSize: "14px",
              display: "inline-block",
              marginBottom: "16px",
            }}
          >
            See our Privacy Policy
          </a>
        )}
      </div>
      <button
        onClick={s360ConfigService.config.sandBox ? undefined : onAccept}
        style={{
          display: "block",
          width: "100%",
          background: configprimaryColor || "#007bff",
          color: "#fff",
          border: "none",
          padding: "12px",
          borderRadius: "6px",
          cursor: "pointer",
          fontWeight: "600",
          fontSize: "15px",
        }}
        data-testid={`${DATA_TEST_ID_PREFIX}-${LIVECHAT_CLICK_EVENTS.PRIVACY_POLICY_ACCEPT}`}
      >
        Continue
      </button>
    </div>
  );
}
